import {Typography,Tag} from "antd";
import {getPopupSizeOption} from '../Common/util';
import {getCodeName} from '../Common/CodeSelect';

export function onClickDetailHandler(value) {
    if (value.columnType == 'assetReport') {

        var _width = '1600';
        var _height = '1400';
        const option = getPopupSizeOption(_width, _height);

        const url = '#/report/'+value.columnType+'/'+value.report_id+'/'+value.asset_cd+'/'+value.com_cd+'/'+value.asset_type;
        const target = value.columnType;
        window.open(url, target, option);

    } 
};

// 자산관리_목록
const redImportantSpan = <span style={{fontWeight: 'bold', color: 'red'}}>*</span>;
export const assetColumnData = [
    {
        title: <div style={{whiteSpace: 'nowrap'}}>{redImportantSpan}자산구분</div>,
        // title: <span style={{fontWeight: 'bold', color: 'blue'}}>자산구분</span>,
        dataIndex: 'asset_type',
        key: 'asset_type',
        width: '100px',
        align: 'center',
        fixed : true,
        ellipsis : false,
        sorter: {
            compare: (a, b) => a.asset_type.localeCompare(b.asset_type),
        },
        render: (_ , rowData ) => {
            return (
                <div style={{whiteSpace: 'nowrap'}}>
                    {getCodeName('asset_type', rowData.asset_type)}
                </div>
            );
        },
        className : 'fix_col',
    },
    {
        title: <div style={{whiteSpace: 'nowrap'}}>{redImportantSpan}자산유형</div>,
        dataIndex: 'asset_spec',
        key: 'asset_spec',
        width: '100px',
        fixed : true,
        align: 'center',
        editable: true,
        sorter: {
            compare: (a, b) => a.asset_spec.localeCompare(b.asset_spec),
        },
        render: (_ , rowData ) => {
            return (
                <div style={{whiteSpace: 'nowrap'}}>
                    {rowData.asset_spec}
                </div>
            );
        },
    },
    {
        title: <div>{redImportantSpan}자산코드</div>,
        dataIndex: 'asset_cd',
        key: 'asset_cd',
        width: '100px',
        align: 'center',
        fixed : true,
        ellipsis : false,
        sorter: {
            compare: (a, b) => a.asset_cd.localeCompare(b.asset_cd),
        },
        editable: false,
    },
    {
        title: <div>{redImportantSpan}자산명</div>,
        dataIndex: 'asset_nm',
        key: 'asset_nm',
        width: '200px',
        fixed : true,
        align: 'center',
        ellipsis : true,
        sorter: {
            compare: (a, b) => a.asset_nm.localeCompare(b.asset_nm),
        },
        editable: true,
        // render: (_ , rowData ) => {
        //     return (
        //         <Typography.Link onClick={() => onClickDetailHandler({columnType: 'assetReport', asset_cd: rowData.asset_cd, com_cd: rowData.com_cd, asset_type: rowData.asset_type})}>
        //             {rowData.asset_nm}
        //         </Typography.Link>
        //     );
        // },
    },
    {
        // title: <div>{redImportantSpan}OS유형</div>,
        title: <div>OS유형</div>,
        dataIndex: 'os_type',
        key: 'os_type',
        width: '100px',
        align: 'center',
        editable: true,
    },
    // {
    //     title: 'Group(사양)',
    //     dataIndex: 'asset_ver',
    //     key: 'asset_ver',
    //     width: '100px',
    //     align: 'center',
    //     className: 'hidden-column-asset',
    //     sorter: {
    //         compare: (a, b) => a.asset_ver.localeCompare(b.asset_ver),
    //     },
    //     editable: false,
    // },
    // {
    //     title: 'AWS계정',
    //     dataIndex: 'aws_nm',
    //     key: 'aws_nm',
    //     width: '70px',
    //     align: 'center',
    //     className: 'hidden-column-asset',
    //     sorter: {
    //         compare: (a, b) => a.aws_nm.localeCompare(b.aws_nm),
    //     },
    //     editable: false,
    // },
    // {
    //     title: 'VPC',
    //     dataIndex: 'vpc_nm',
    //     key: 'vpc_nm',
    //     width: '70px',
    //     align: 'center',
    //     className: 'hidden-column-asset',
    //     sorter: {
    //         compare: (a, b) => a.vpc_nm.localeCompare(b.vpc_nm),
    //     },
    //     editable: false,
    // },
    // {
    //     title: 'Cluster',
    //     dataIndex: 'cluster_nm',
    //     key: 'cluster_nm',
    //     width: '70px',
    //     align: 'center',
    //     className: 'hidden-column-asset',
    //     sorter: {
    //         compare: (a, b) => a.cluster_nm.localeCompare(b.cluster_nm),
    //     },
    //     editable: false,
    // },
    // {
    //     title: 'OS및버전',
    //     dataIndex: 'os_ver',
    //     key: 'os_ver',
    //     width: '200px',
    //     align: 'center',
    //     sorter: {
    //         compare: (a, b) => a.os_ver.localeCompare(b.os_ver),
    //     },
    //     editable: false,
    // },
    {
        title: <div>{redImportantSpan}개수</div>,
        dataIndex: 'asset_qty',
        key: 'asset_qty',
        width: '70px',
        align: 'center',
        sorter: {
            compare: (a, b) => a.asset_qty-b.asset_qty,
        },
        editable: true,
    },
    {
        title: <div>{redImportantSpan}IP주소</div>,
        dataIndex: 'asset_ip',
        key: 'asset_ip',
        width: '180px',
        align: 'center',
        ellipsis : false,
        sorter: {
            compare: (a, b) => a.asset_ip.localeCompare(b.asset_ip),
        },
        editable: true,
    },
    {
        title: "외부IP",
        dataIndex: 'public_ip',
        key: 'public_ip',
        width: '100px',
        align: 'center',
        ellipsis : false,
        editable: true,
    },
    // {
    //     title: 'MAC',
    //     dataIndex: 'mac_no',
    //     key: 'mac_no',
    //     width: '100px',
    //     align: 'center',
    //     sorter: {
    //         compare: (a, b) => a.mac_no.localeCompare(b.mac_no),
    //     },
    //     editable: true,
    // },
    {
        title: <div>{redImportantSpan}SSH Port</div>,
        dataIndex: 'ssh_port',
        key: 'ssh_port',
        width: '100px',
        align: 'center',
        editable: true,
    },
    // {
    //     title: 'ARCH',
    //     dataIndex: 'arch',
    //     key: 'arch',
    //     width: '100px',
    //     align: 'center',
    //     sorter: {
    //         compare: (a, b) => a.arch.localeCompare(b.arch),
    //     },
    //     editable: true,
    // },
    // {
    //     title: 'CPU',
    //     dataIndex: 'cpu',
    //     key: 'cpu',
    //     width: '100px',
    //     align: 'center',
    //     sorter: {
    //         compare: (a, b) => a.cpu.localeCompare(b.cpu),
    //     },
    //     editable: true,
    // },
    {
        title: <div>{redImportantSpan}담당팀</div>,
        dataIndex: 'depart_nm',
        key: 'depart_nm',
        width: '100px',
        align: 'center',
        editable: true,
    },
    {
        title: <div>{redImportantSpan}담당자</div>,
        dataIndex: 'manager_nm',
        key: 'manager_nm',
        width: '100px',
        align: 'center',
        editable: true,
    },
    {
        title: <div>{redImportantSpan}관리자</div>,
        dataIndex: 'supervisor_nm',
        key: 'supervisor_nm',
        width: '100px',
        align: 'center',
        editable: true,
    },
    {
        title: <div>{redImportantSpan}설치장소</div>,
        dataIndex: 'location_nm',
        key: 'location_nm',
        width: '180px',
        align: 'center',
        ellipsis : false,
        editable: true,
    },
    {
        title: <div>{redImportantSpan}용도(서비스)</div>,
        dataIndex: 'service_nm',
        key: 'service_nm',
        width: '180px',
        align: 'center',
        ellipsis : false,
        editable: true,
    },
    // {
    //     title: <div>{redImportantSpan}사용여부</div>,
    //     dataIndex: 'use_yn',
    //     key: 'use_yn',
    //     width: '75px',
    //     align: 'center',
    //     sorter: {
    //         compare: (a, b) => a.use_yn.localeCompare(b.use_yn),
    //     },
    //     editable: true,
    // },
    // {
    //     title: <div>{redImportantSpan}ISMS대상</div>,
    //     dataIndex: 'isms_yn',
    //     key: 'isms_yn',
    //     width: '75px',
    //     align: 'center',
    //     editable: true,
    // },
    {
        title: <div>{redImportantSpan}취약점분석</div>,
        dataIndex: 'rms_yn',
        key: 'rms_yn',
        width: '85px',
        align: 'center',
        editable: true,
    },
    {
        title: '비고',
        dataIndex: 'remark',
        key: 'remark',
        width: '100px',
        align: 'center',
        editable: true,
    },
    {
        title: <div>{redImportantSpan}기밀성</div>,
        dataIndex: 'confidential_score',
        key: 'confidential_score',
        width: '70px',
        align: 'center',
        editable: true,
        className: 'edit_col',
    },
    {
        title: <div>{redImportantSpan}무결성</div>,
        dataIndex: 'integrity_score',
        key: 'integrity_score',
        width: '70px',
        align: 'center',
        editable: true,
        className: 'edit_col',
    },
    {
        title: <div><span style={{fontWeight: 'bold', color: 'red'}}>*</span>가용성</div>,
        dataIndex: 'availability_score',
        key: 'availability_score',
        width: '70px',
        align: 'center',
        editable: true,
        className: 'edit_col',
    },
    {
        title: '합계',
        dataIndex: 'score_sum',
        key: 'score_sum',
        width: '70px',
        align: 'center',
        className: 'fix_col',
        render: (_ , rowData ) => {
            let confidential = rowData.confidential_score?parseInt(rowData.confidential_score):0;
            let integrity = rowData.integrity_score?parseInt(rowData.integrity_score):0;
            let availability = rowData.availability_score?parseInt(rowData.availability_score):0;
            let score_sum = confidential + integrity  + availability;
            return (
                score_sum
            );
        },
    },
    {
        title: <div>{redImportantSpan}보안등급</div>,
        dataIndex: 'asset_grd',
        key: 'asset_grd',
        width: '90px',
        align: 'center',
        sorter: {
            compare: (a, b) => a.asset_grd.localeCompare(b.asset_grd),
        },
        className: 'fix_col',
        render: (_ , rowData ) => {
            let tag_color ='';
            if(rowData.asset_grd == 'H') {
                tag_color = 'volcano';
            } else if(rowData.asset_grd == 'M') {
                tag_color = 'geekblue';
            } else {
                tag_color = 'green';
            }
            return (
                <Tag color={tag_color} key={rowData.asset_grd}>
                    {rowData.asset_grd}
                </Tag>
            );
        },
    },
    {
        title: <div>{redImportantSpan}자산평가</div>,
        dataIndex: 'asset_rnk',
        key: 'asset_rnk',
        width: '90px',
        align: 'center',
        sorter: {
            compare: (a, b) => a.asset_rnk - b.asset_rnk,
        },
        className: 'fix_col',
        render: (_ , rowData ) => {
            let tag_color ='';
            if(rowData.asset_rnk == '3') {
                tag_color = 'volcano';
            } else if(rowData.asset_rnk == '2') {
                tag_color = 'geekblue';
            } else {
                tag_color = 'green';
            }
            return (
                <Tag color={tag_color} key={rowData.asset_rnk}>
                    {rowData.asset_rnk}
                </Tag>
            );
        },
    },

];
